(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'react', 'prop-types', 'lodash.omit', 'lodash.noop', './TreeNode', './search'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('prop-types'), require('lodash.omit'), require('lodash.noop'), require('./TreeNode'), require('./search'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.propTypes, global.lodash, global.lodash, global.TreeNode, global.search);
        global.ReactLazyTree = mod.exports;
    }
})(this, function (exports, _react, _propTypes, _lodash, _lodash3, _TreeNode, _search) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _lodash2 = _interopRequireDefault(_lodash);

    var _lodash4 = _interopRequireDefault(_lodash3);

    var _TreeNode2 = _interopRequireDefault(_TreeNode);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var ReactLazyTree = function (_React$Component) {
        _inherits(ReactLazyTree, _React$Component);

        /* istanbul ignore next */
        function ReactLazyTree(props) {
            _classCallCheck(this, ReactLazyTree);

            var _this = _possibleConstructorReturn(this, (ReactLazyTree.__proto__ || Object.getPrototypeOf(ReactLazyTree)).call(this, props));

            var childrenPropertyName = props.childrenPropertyName,
                data = props.data,
                mapInitialActiveNode = props.mapInitialActiveNode;

            var activePath = '';
            if (typeof mapInitialActiveNode === 'function') {
                activePath = (0, _search.findFirstNode)(_this.normalizeData(data), mapInitialActiveNode, childrenPropertyName);
            }

            _this.state = {
                activePath: activePath
            };

            _this.onActiveNodeChanged = _this.onActiveNodeChanged.bind(_this);

            _this.isTouchEnv = false;
            return _this;
        }

        _createClass(ReactLazyTree, [{
            key: 'onActiveNodeChanged',
            value: function onActiveNodeChanged(e, node, depth, index, path) {
                var activePath = this.state.activePath;
                var interactiveStartDepth = this.props.interactiveStartDepth;


                if (this.isOnActivePath(path, activePath, depth)) {
                    path = this.slicePathAtDepth(path, depth);
                }

                if (depth >= interactiveStartDepth && interactiveStartDepth !== -1) {
                    this.setState({
                        activePath: path
                    });
                }

                this.props.onActiveNodeChanged({ e: e, node: node, depth: depth, index: index, activePath: path });
            }
        }, {
            key: 'isOnActivePath',
            value: function isOnActivePath(path, activePath, depth) {
                var ap = this.slicePathAtDepth(activePath, depth + 1);
                var p = this.slicePathAtDepth(path, depth + 1);
                return ap === p;
            }
        }, {
            key: 'slicePathAtDepth',
            value: function slicePathAtDepth(path, depth) {
                return path.split(',').slice(0, depth).join();
            }
        }, {
            key: 'normalizeData',
            value: function normalizeData(data) {
                if (!Array.isArray(data)) {
                    return [data];
                }

                return data;
            }
        }, {
            key: 'render',
            value: function render() {
                var omitions = ['isInteractive', 'mapInitialActiveNode', 'data'];

                return _react2.default.createElement(_TreeNode2.default, _extends({}, (0, _lodash2.default)(this.props, omitions), {
                    activePath: this.state.activePath,
                    node: this.normalizeData(this.props.data),
                    onActiveNodeChanged: this.onActiveNodeChanged
                }));
            }
        }]);

        return ReactLazyTree;
    }(_react2.default.Component);

    ReactLazyTree.propTypes = {
        childrenPropertyName: _propTypes2.default.string,
        data: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]).isRequired,
        interactiveStartDepth: _propTypes2.default.number,
        mapInitialActiveNode: _propTypes2.default.func,
        mapListClassName: _propTypes2.default.func,
        mapListItemClassName: _propTypes2.default.func,
        mapNodeContent: _propTypes2.default.func.isRequired,
        onActiveNodeChanged: _propTypes2.default.func,
        shouldLazyRender: _propTypes2.default.bool,
        shouldShowAllNodes: _propTypes2.default.bool,
        verticalAnimationConfig: _propTypes2.default.shape({
            durationInMs: _propTypes2.default.number,
            timing: _propTypes2.default.string
        })
    };

    ReactLazyTree.defaultProps = {
        childrenPropertyName: 'children',
        interactiveStartDepth: 0,
        onActiveNodeChanged: _lodash4.default
    };

    exports.default = ReactLazyTree;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-lazy-tree/dist/ReactLazyTree.js
// module id = 109
// module chunks = 0